export default __webpack_public_path__ + "assets/10n.38971dda.svg";